export default __webpack_public_path__ + "static/media/STATESMAN.b1135300.png";